import React from 'react'
import './About.css'
import { Nav } from '../../components'
import { Footer } from '../../containers'
import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet'
import { images } from '../../constants'

const About = () => {
  const imageAnimate = {
    offscreen: { x: -50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      rotate: [0, 10, 0],
      transition: { type: 'spring', bounce: 0.4, duration: 1 },
    },
  }
  const textAnimate = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.4, duration: 2 },
    },
  }
  return (
    <div>
      <Helmet>
        <title>About Us - Sushi edge</title>
      </Helmet>
      <div className="container-xxl">
        <Nav />
      </div>

      <motion.div
        className="about-container p-5"
        initial={'offscreen'}
        whileInView={'onscreen'}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ staggerChildren: 0.5 }}
      >
        <motion.h1
          className="text-center text-light p-5"
          variants={textAnimate}
        >
          About Us
        </motion.h1>
        <div className="justify-content-center align-items-center mt-5 mb-5">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-5">
              <motion.img
                src={images.about}
                className="img-fluid p-3 mb-5"
                variants={imageAnimate}
              />
            </div>
            <div className="col-md-4">
              <motion.p
                variants={textAnimate}
                className="text-light"
              >
                Sushi Edge serves a Japanese classic with a Kiwi touch. Serving
                fresh, fast and healthy food is the main purpose at Sushi Edge.
              </motion.p>
              <motion.p
                variants={textAnimate}
                className="text-light"
              >
                Every day, our team members prepare over 60 different types of
                sushi and meals, with great passion. We are proud to deliver
                superior food to local people, to satisfy their demands, and we
                are also extremely grateful for the trust and support from our
                customers over the years. We will continue to serve our
                customers with the same passion and remain true to our original
                aspiration.
              </motion.p>
            </div>
          </div>
        </div>
      </motion.div>
      <Footer />
    </div>
  )
}

export default About
